import styled from "@emotion/styled";
import { SubscriptionButton } from "scmp-sdk/components/rosetta/subscription-button/styles";

import { theme } from "shared/lib/styles";

import AlertIcon from "./alert-icon.svg";

export const StyledSubscriptionButton = styled(SubscriptionButton)`
  display: flex;

  color: #eb4254;

  border: 1px solid #eb4254;

  background: #fff6f7;

  ${theme.breakpoints.up("tablet")} {
    border-radius: 2px;
  }
`;

export const StyledAlertIcon = styled(AlertIcon)`
  inline-size: 17.5px;
  margin-inline-end: 5px;
  ${theme.breakpoints.up("tablet")} {
    margin-inline-end: 9px;
  }
`;
